import { getApiClient } from '@signalvote/api-client';
import type { SetPurchaserRequest } from '@signalvote/shared';
import { defineWrite, edit, every } from '@/lib/data';
import { useVolunteers } from './useVolunteers';

const api = getApiClient();

/**
 * Names or un-names a purchaser. The server answers CampaignUser, which the staff list declares;
 * the returned version lands in the list at once, so a quick second toggle sends the new token.
 */
export const useSetPurchaser = defineWrite({
  send: ({ userId, ...request }: SetPurchaserRequest & { userId: string }) => api.purchasers.set(userId, request),
  land: (purchaser) => [
    edit(useVolunteers, every, (staff) =>
      staff.map((row) =>
        row.userId === purchaser.userId
          ? { ...row, isPurchaser: purchaser.isPurchaser, purchaserVersion: purchaser.purchaserVersion }
          : row,
      ),
    ),
  ],
});
